class GiftBoxes {
  constructor() {
    this.configs = {
      selectors: {
        container: '[data-gift-box-container]',
        closeButton: '[data-gift-box-inner-content-close]',
        openButton: '[data-gift-box-inner-content-open]',
        giftBoxInnerContent: '[data-gift-box-inner-content]',
        giftBoxOuterContent: '[data-gift-box-outer-content]',
        giftBoxAddToCartButtons: '[data-gift-box-add-to-cart-button]',
        giftBoxesSliderContainer: '[data-gift-boxes-slider-container]',
        giftBoxProductsContainer: '[data-gift-box-products-container]',
        giftBoxCheckboxesList: '[data-choose-gift-box-checkbox]',
        giftBoxInvoice: '[data-gift-box-invoice]',
      },
      classes: {
        hidden: 'hidden',
      }
    };

    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupEventListeners();
    this.ajaxAPI = new API('ajax');
    this.cart = document.querySelector('cart-drawer');
    if (this.elements.giftBoxProductsContainer.childElementCount == 0) {
      return; 
    }
  }

  _getElements() {
    const container = document.querySelector(this.configs.selectors.container);
    return container ? {
      container,
      closeButton: container.querySelector(this.configs.selectors.closeButton),
      openButton: container.querySelector(this.configs.selectors.openButton),
      giftBoxInnerContent: container.querySelector(this.configs.selectors.giftBoxInnerContent),
      giftBoxOuterContent: container.querySelector(this.configs.selectors.giftBoxOuterContent),
      giftBoxAddToCartButton: container.querySelector(this.configs.selectors.giftBoxAddToCartButtons),
      giftBoxesSliderContainer: container.querySelector(this.configs.selectors.giftBoxesSliderContainer),
      giftBoxProductsContainer: container.querySelector(this.configs.selectors.giftBoxProductsContainer),
      giftBoxCheckboxesList: container.querySelectorAll(this.configs.selectors.giftBoxCheckboxesList),
      giftBoxInvoice: container.querySelector(this.configs.selectors.giftBoxInvoice),
    } : {};
  }

  _setupEventListeners() {
    this.elements.openButton.addEventListener('click', this._openGiftBoxesPopupClick);
    this.elements.closeButton.addEventListener('click', this._closeGiftBoxesPopupClick);
    this.elements.giftBoxAddToCartButton.addEventListener('click', this._giftBoxAddToCartButtonClick);
    for (const giftBoxCheckbox of this.elements.giftBoxCheckboxesList) {
      giftBoxCheckbox.addEventListener('change', this._chooseGiftBoxProduct);
    }
  }

  _openGiftBoxesPopup() {
    this.elements = this._getElements();
    this.elements.giftBoxInnerContent.classList.remove(this.configs.classes.hidden);
    this.elements.giftBoxOuterContent.classList.add(this.configs.classes.hidden);
  }

  _openGiftBoxesPopupClick = () => {
    this._openGiftBoxesPopup();
  }

  _closeGiftBoxesPopup() {
    this.elements.giftBoxInnerContent.classList.add(this.configs.classes.hidden);
    this.elements.giftBoxOuterContent.classList.remove(this.configs.classes.hidden);
  }

  _closeGiftBoxesPopupClick = () => {
    this._closeGiftBoxesPopup();
  }

  async _giftBoxAddToCart(variantId, setInvoicePropertyValue) {
    const addToCartData = {
      id: variantId,
      quantity: 1,
      properties: {
        'Invoice': setInvoicePropertyValue,
      },
      sections: this.cart.getSectionsToRender().map((section) => section.id),
    };

    const data = await this.ajaxAPI.cartAdd(addToCartData);
    await this.cart.renderContents(data);
    this._attachDynamicEvents();
  }

  _attachDynamicEvents() {
    const elementsConfigs = [
      {
        selector: '.gift-box-add-to-cart-button',
        eventName: 'click',
        functionName: '_giftBoxAddToCartButtonClick',
      },
      {
        selector: this.configs.selectors.openButton,
        eventName: 'click',
        functionName: '_openGiftBoxesPopupClick',
      },
      {
        selector: this.configs.selectors.closeButton,
        eventName: 'click',
        functionName: '_closeGiftBoxesPopupClick',
      }
    ];

    this._setupEventListenersForDynamicElements(elementsConfigs);
  }

  _chooseGiftBoxProduct = (element) => {
    const clickedId = element.target.id;
    const elementVariantId = element.target.dataset.variantId;
    this.elements.giftBoxAddToCartButton.setAttribute('data-variant-id',elementVariantId)

    for (const giftBoxCheckbox of this.elements.giftBoxCheckboxesList) {
      const currentId = giftBoxCheckbox.id;
      if (element.target.checked) {
        this.elements.giftBoxAddToCartButton.classList.remove('disabled');
      } else {
        this.elements.giftBoxAddToCartButton.classList.add('disabled');
      }
      if (clickedId === currentId) {
        continue;
      }
      giftBoxCheckbox.checked = false;
    }
  }

  _giftBoxAddToCartButtonClick = async (event, setInvoicePropertyValue) => {
    const firstAvailableVariantId = event.currentTarget.dataset.variantId;
    const isInvoiceInputChecked = this.elements.giftBoxInvoice.querySelector('input').checked;
    if (isInvoiceInputChecked) {
      setInvoicePropertyValue = 'No Invoice';
    } else {
      setInvoicePropertyValue = '';
    }
    await this._giftBoxAddToCart(firstAvailableVariantId, setInvoicePropertyValue);
  }

  _addEventListenner = (listener, query, func) => {
    document.querySelectorAll(query).forEach(item => {
      item.addEventListener(listener, (element) => {
        this[func](element);
      });
    });
  }

  _setupEventListenersForDynamicElements(elementsConfigs) {
    for (const elementConfig of elementsConfigs) {
      this._addEventListenner(elementConfig.eventName, elementConfig.selector, elementConfig.functionName);
    }
  }

}
